import React from 'react';
import { InputNumber } from 'antd';

export default function CustomInputNumber(props) {
	return (
		<>
			<InputNumber {...props} />
		</>
	);
}
